import { render, staticRenderFns } from "./DashboardPantalla.vue?vue&type=template&id=70fe4a28&"
import script from "./DashboardPantalla.vue?vue&type=script&lang=ts&"
export * from "./DashboardPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports